import {
  APPLICATIONS_NEW_PATH,
  APPLICATIONS_PATH,
  buildAdmissionLocation,
  buildApplicationLocation,
  buildParksLocation,
  buildProfileLocation,
  isDefaultEntryPath,
  isPreSettlementPath,
  isPublicPath,
  PROFILE_PATH,
  WORKBENCH_PATH,
} from '@/park/scope';
import type { EnterpriseBootstrapState } from '@/services/bff/types/onboarding';
import type { Park } from '@/services/bff/types/park';

export {
  APPLICATIONS_NEW_PATH,
  APPLICATIONS_PATH,
  buildAdmissionLocation,
  buildApplicationLocation as buildPendingLocation,
  buildParksLocation,
  buildProfileLocation,
  PROFILE_PATH,
};

export const PARKS_PATH = APPLICATIONS_NEW_PATH;
export const ADMISSION_PATH = APPLICATIONS_NEW_PATH;
export const PENDING_PATH = APPLICATIONS_PATH;
export const MY_PARK_PATH = '/parks';

export const readAdmissionParkUuid = (
  search?: string | null,
  stateParkUuid?: string | null,
) => {
  const query = search?.startsWith('?') ? search.slice(1) : search || '';
  return new URLSearchParams(query).get('parkUuid') || stateParkUuid || '';
};

export const readPendingApplicationUuid = (search?: string | null) => {
  const query = search?.startsWith('?') ? search.slice(1) : search || '';
  return new URLSearchParams(query).get('applicationUuid') || '';
};

export const findAdmissionPark = <T extends { uuid?: string }>(
  parkUuid: string,
  lists: Array<T[] | undefined>,
) => {
  if (!parkUuid) return undefined;
  for (const list of lists) {
    const matched = list?.find((item) => item.uuid === parkUuid);
    if (matched) return matched;
  }
  return undefined;
};

const profilePath = (pathname: string) => pathname === PROFILE_PATH;

export const buildPendingAdmissionPath = (
  pendingApplicationUuid?: string | null,
) => {
  if (!pendingApplicationUuid) return APPLICATIONS_PATH;
  return `${APPLICATIONS_PATH}/${encodeURIComponent(pendingApplicationUuid)}`;
};

export const getEnterpriseRouteRedirect = (
  pathname: string,
  state: EnterpriseBootstrapState,
  _accessibleParks: Park[] = [],
  _currentParkUuid?: string | null,
  pendingApplicationUuid?: string | null,
) => {
  if (isPublicPath(pathname)) return null;

  if (state === 'PROFILE_REQUIRED') {
    if (profilePath(pathname) || pathname.startsWith('/parks/invitations')) {
      return null;
    }
    return PROFILE_PATH;
  }

  if (state === 'PARK_REQUIRED') {
    return isPreSettlementPath(pathname) ? null : APPLICATIONS_NEW_PATH;
  }

  if (state === 'ADMISSION_PENDING') {
    if (isPreSettlementPath(pathname)) return null;
    return buildPendingAdmissionPath(pendingApplicationUuid);
  }

  if (state === 'ACTIVE' || state === 'SUSPENDED_ONLY') {
    return isDefaultEntryPath(pathname) ? WORKBENCH_PATH : null;
  }

  return null;
};
